import { render, staticRenderFns } from "./NavBar.component.vue?vue&type=template&id=c8d93b7c&scoped=true&"
import script from "./NavBar.component.vue?vue&type=script&lang=ts&"
export * from "./NavBar.component.vue?vue&type=script&lang=ts&"
import style0 from "./NavBar.component.vue?vue&type=style&index=0&id=c8d93b7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d93b7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAppBar,VBottomNavigation,VBtn,VCol,VIcon,VList,VListItem,VListItemTitle,VMenu,VRow})
